import * as React from "react";
import { useDroppable } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface KanbanColumnProps {
  id: string;
  title: string;
  count: number;
  children: React.ReactNode;
  itemIds: string[];
}

export function KanbanColumn({ id, title, count, children, itemIds }: KanbanColumnProps) {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div className="flex w-[280px] min-w-[280px] shrink-0 flex-col lg:w-auto lg:min-w-0 lg:flex-1">
      <div className="mb-3 flex items-center gap-2 px-1">
        <h3 className="text-xs font-medium tracking-widest text-muted-foreground uppercase">
          {title}
        </h3>
        <Badge variant="secondary" className="px-1.5 py-0 text-[10px]">
          {count}
        </Badge>
      </div>
      <div
        ref={setNodeRef}
        className={cn(
          "min-h-[200px] flex-1 space-y-2 rounded-lg border border-border bg-muted/30 p-2 transition-colors",
          isOver && "border-primary/30 bg-primary/5",
        )}
      >
        <SortableContext items={itemIds} strategy={verticalListSortingStrategy}>
          {children}
        </SortableContext>
      </div>
    </div>
  );
}
